import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CdnPathPipe } from '@uc/utilities';
import { BaseNavlinkComponent } from '../base-navlink.component';
import { NgOptimizedImage } from '@angular/common';
import { WriteReviewBtnComponent } from '@uc/web/shared/buttons';
import { ArrowRightV3SvgComponent } from '@uc/shared/svg';
import { UniImpressionGADirective, UniProfileGADirective } from '@uc/web/analytics';
import { Product, ProductEnum } from '@uc/shared/data-models';

@Component({
	selector: 'uc-nav-card-uni',
	imports: [
		CdnPathPipe,
		RouterLink,
		NgOptimizedImage,
		WriteReviewBtnComponent,
		ArrowRightV3SvgComponent,
		UniProfileGADirective,
		UniImpressionGADirective,
	],
	templateUrl: './nav-card-uni.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavCardUniComponent extends BaseNavlinkComponent {
	slug = input.required({
		transform: (slug: string) => `/universities/${slug}`,
	});
	image = input.required<string>();
	uniId = input.required<number>();
	uniName = input.required<string>();
	description = input.required<string>();
	noReviews = input.required<boolean>();
	linkText = input.required<string>();
	product = input.required<Product>();
	searchOrderPosition = input.required<number>();

	showReviewButton = computed(
		() => this.noReviews() && this.uniId() && this.uniName() && this.slug(),
	);

	ugso = computed(() =>
		this.product() === ProductEnum.Undergraduate ? this.searchOrderPosition() : null,
	);
	cleso = computed(() =>
		this.product() === ProductEnum.Clearing ? this.searchOrderPosition() : null,
	);
}
